'use client';
import { MenuStyled } from './menu-styles';

const Menu = MenuStyled;

export default Menu;
